import { render, staticRenderFns } from "./AgentCustomerDetail.vue?vue&type=template&id=5d643981&scoped=true&"
import script from "./AgentCustomerDetail.vue?vue&type=script&lang=js&"
export * from "./AgentCustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./AgentCustomerDetail.vue?vue&type=style&index=0&id=5d643981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d643981",
  null
  
)

export default component.exports